import styled from 'styled-components'
import {Link} from 'react-router-dom'

const StyledLink = styled(Link)`
   text-decoration: none;
   color: #2172BA;
`

export default StyledLink